import React from 'react';
import { Navigate } from 'react-router-dom';

// Чистый редирект: рендерить Layout ради него смысла нет — он тут же размонтируется.
const Scene = () => <Navigate to="/dashboard" replace />;

export default Scene;
